import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areLogoStatesEqual, LOGO_INITIAL_STATE } from './cost-to-build-client-ui-logo.state';
import type { LogoState } from './cost-to-build-client-ui-logo.types';

export const LogoStore = signalStore(
    withState(LOGO_INITIAL_STATE),
    withComputed((store) => ({
        state: computed<LogoState>(() => ({
            alt: store.alt(),
            src: store.src(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<LogoState>): void => {
            const nextState: LogoState = {
                ...store.state(),
                ...patch,
            };

            if (areLogoStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return {
            setState,
        };
    })
);
